import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-blueprint flex items-center justify-center px-4">
      <div className="max-w-md w-full border border-white/10 bg-slate-950 p-10 text-center">
        <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500">// Checkout cancelled</div>
        <h1 className="font-display text-3xl font-black uppercase tracking-tight mt-3">No worries — nothing was charged.</h1>
        <p className="text-slate-400 mt-3">You can still pledge without paying, or try the card flow again.</p>
        <Link to="/" className="inline-block mt-6 px-6 py-3 bg-kinetic hover:bg-[#FF5E1A] text-black font-bold uppercase tracking-wide">
          Back to campaign
        </Link>
      </div>
    </div>
  );
}
